// extracted by mini-css-extract-plugin
module.exports = {"loadingCourses":"Courses_loadingCourses__Vgz0g","noCourses":"Courses_noCourses__ItEHm","courseCount":"Courses_courseCount__eh8dS"};